module.exports = __webpack_public_path__ + "img/pro_four_5.01565c96.jpg";